var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKycModalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9660_11370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0014 0.600586C33.1186 0.600586 21.7225 5.32099 13.3202 13.7234C4.91779 22.1258 0.197379 33.5218 0.197379 45.4046C0.176716 54.5413 2.98045 63.4611 8.22476 70.9429C9.64179 72.9992 11.2413 74.9236 13.0039 76.6927C17.1598 80.9326 22.117 84.3042 27.5873 86.6115C33.0576 88.9189 38.932 90.1161 44.869 90.1335C50.806 90.1508 56.6872 88.9881 62.171 86.7127C67.6547 84.4374 72.6315 81.0949 76.8122 76.8794C78.5967 75.1337 80.2096 73.2207 81.6286 71.1669C86.344 64.4575 89.1275 56.5827 89.6758 48.4005C90.2242 40.2183 88.5164 32.0425 84.7384 24.7639C80.9605 17.4854 75.2575 11.3833 68.2506 7.12261C61.2438 2.86189 53.202 0.605943 45.0014 0.600586V0.600586ZM76.2522 65.7904C74.9014 67.875 73.3236 69.8034 71.5477 71.5402C68.0724 75.0793 63.9266 77.8905 59.3527 79.8095C54.7787 81.7284 49.8682 82.7168 44.908 82.7168C39.9478 82.7168 35.0374 81.7284 30.4634 79.8095C25.8895 77.8905 21.7437 75.0793 18.2683 71.5402C16.503 69.722 14.9384 67.7192 13.6012 65.5664C9.71117 59.5627 7.64877 52.5583 7.66471 45.4046C7.66471 35.5023 11.5984 26.0056 18.6004 19.0036C25.6023 12.0016 35.0991 8.06792 45.0014 8.06792C54.9037 8.06792 64.4004 12.0016 71.4024 19.0036C78.4044 26.0056 82.338 35.5023 82.338 45.4046C82.3489 52.6491 80.2328 59.7374 76.2522 65.7904V65.7904Z",
    fill: "#41B661"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.53 32.4857L43.693 58.2853L38.4285 63.6244L33.1641 58.3226L38.4285 53.0582L64.2655 27.2212L69.53 32.4857Z",
    fill: "#41B661"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1992 24.8691L31.9329 23.0022L33.7997 19.2686L35.6666 23.0022L39.4002 24.8691L35.6666 26.7359L33.7997 30.4696L31.9329 26.7359L28.1992 24.8691Z",
    fill: "#41B661"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0664 64.0725L60.568 62.8404L61.8001 60.3389L63.0322 62.8404L65.5337 64.0725L63.0322 65.3047L61.8001 67.8062L60.568 65.3047L58.0664 64.0725Z",
    fill: "#41B661"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9660_11370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white",
    transform: "translate(0 0.355469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycModalIcon);
export default __webpack_public_path__ + "static/media/kyc-modal-icon.277c48ed.svg";
export { ForwardRef as ReactComponent };